import { initials } from '../lib/format';

export function Avatar({ name, size = 'md' }: { name: string; size?: 'sm' | 'md' | 'lg' }) {
  return (
    <span className={`ui-avatar${size !== 'md' ? ` ui-avatar--${size}` : ''}`} aria-hidden>
      {initials(name)}
    </span>
  );
}
